import React from 'react';
import preloader from '../../image/preloader.gif'

const Loading = () => {
    return (
        <div className={'w-full h-full fixed top-0 left-0 bg-white z-40'}>
            <img className={'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/12'} src={preloader} alt=""/>
        </div>
    );
};

export default Loading;